import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import InventoryForm from './InventoryForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { useSelector } from 'react-redux'

const Inventory = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'inventario' })

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.inventory.get_inventory().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.inventory.inventory_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idInventory) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idInventory, view = 0 } = $this.dataset

        Controllers.inventory.get_inventory_id({ p_id_inventory: idInventory }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idInventory}`)
            setDataUpdated({ data: res.data, viewSubmit: parseInt(view) === 0 })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.inventory.inventory_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idInventory, nameInventory } = e.currentTarget.dataset
        setDataDeleted({
            p_id_inventory: idInventory,
            p_name_inventory: nameInventory
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_inventory', text: 'ID', align: 'center' },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'name_inventory', text: 'Nombre', align: 'center' },
                { name: 'date_inventory', text: 'Fecha', align: 'center' },
                { name: 'total_inventory', text: 'Costo Diferencia', align: 'center' },
                { name: 'qty_difference_total_inventory', text: 'Cantiad Diferencia', align: 'center' },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {actionsModule?.update ? <Button variant={actionsModule?.update.color_action} className="mr-1" size="xs" data-id-inventory={u.id_inventory} onClick={handleGet}>
                                <i className={actionsModule?.update.icon}></i>
                            </Button> : ''}
                            {actionsModule?.view ? <Button variant={actionsModule?.view.color_action} className="mr-1" size="xs" data-view={1} data-id-inventory={u.id_inventory} onClick={handleGet}>
                                <i className={actionsModule?.view.icon}></i>
                            </Button> : ''}
                            {actionsModule?.delete ? <Button variant={actionsModule?.delete.color_action} size="xs" data-id-inventory={u.id_inventory} data-name-inventory={u.name_inventory} onClick={handleShowModalDelete}>
                                <i className={actionsModule?.delete.icon}></i>
                            </Button> : ''}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                {actionsModule?.new ? <Button variant={actionsModule?.new.color_action} size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> {actionsModule?.new.name_action} {nameSingle}
                </Button> : ''}
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InventoryForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_inventory} - {dataDeleted.p_name_inventory}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Inventory